// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1uT39","icon":"styles_icon___6v5c"};